import appConstants from "../../../../appConstants";
import {
  MultiSelectFilter,
  DateTimeFilter,
} from "../../../dataGrid/columnFilters";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration(config) {
    return GridConfig.getDefaultConfiguration();
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.DuplicateCustomerGrid,
      keyColumn: "customerID",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Route",
          field: "route",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_ROUTE,
        },
        {
          headerName: "Customer ID",
          field: "customerCode",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_CUSTOMER,
        },
        {
          headerName: "Customer",
          field: "customer",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_CUSTOMER,
        },
        {
          headerName: "Address",
          field: "address",
          tooltipField: "address",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_ADDRESS,
        },
        {
          headerName: "City",
          field: "city",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_CITY,
        },
        {
          headerName: "State",
          field: "state",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_CITY,
        },
        {
          headerName: "Zip",
          field: "zip",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_CITY,
        },
        {
          headerName: "Delivery Window",
          field: "deliveryWindow",
          cellClass: "gridCell-leftAlign",
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.TIME,
          },
          minWidth:
            appConstants.columnWidth.DUPLICATE_CUSTOMERS_DELIVERY_WINDOW,
        },
      ],
    };
  }
}
